import React from 'react';
import styled from 'styled-components';
import {Form} from 'components/antd';
import {useFormik} from 'formik';
import useSearchParams from '../../useSearchParams';
import {InputNumber} from 'components';

const EmployeeNumberFilter = () => {
  const {query, setQuery} = useSearchParams();

  const {employeeNumber = {from: null, to: null}} = query;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      employeeNumber,
    },
    onSubmit: (values) => {
      setQuery(values);
    },
  });

  return (
    <Container>
      <Form.Item>
        <StyledInputNumber
          min={1}
          value={formik.values.employeeNumber?.from}
          onChange={(value) =>
            formik.setFieldValue('employeeNumber.from', value)
          }
          onBlur={() => formik.handleSubmit()}
        />
        <span> 人 〜 </span>
        <StyledInputNumber
          min={1}
          value={formik.values.employeeNumber?.to}
          onChange={(value) => formik.setFieldValue('employeeNumber.to', value)}
          onBlur={() => formik.handleSubmit()}
        />
        <span> 人</span>
      </Form.Item>
    </Container>
  );
};

const Container = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;

const StyledInputNumber = styled(InputNumber)`
  border: 1px solid rgb(217, 217, 217) !important;
  width: 160px;
`;

export default EmployeeNumberFilter;
